// // src/components/Videos.jsx
// import React, { useState, useEffect } from 'react';
// import { Card, CardContent, CardMedia, Grid, Typography, Box, Modal, CircularProgress } from '@mui/material';
// import ReactPlayer from 'react-player'; 
// import axios from 'axios'; 

// const Videos = () => {
//     const [videos, setVideos] = useState([]); 
//     const [openModal, setOpenModal] = useState(false); 
//     const [selectedVideo, setSelectedVideo] = useState(''); 
//     const [loading, setLoading] = useState(true); 

  
//     const fetchVideos = async () => {
//         try {
//             const response = await axios.get('https://wedding-backend-pi.vercel.app/api/videos/'); 
//             setVideos(response.data); 
//             setLoading(false);
//         } catch (error) {
//             console.error('Error fetching videos:', error);
//             setLoading(false); 
//         }
//     };


//     const handleOpenModal = (videoUrl) => {
//         setSelectedVideo(videoUrl);
//         setOpenModal(true);
//     };

  
//     const handleCloseModal = () => {
//         setOpenModal(false);
//         setSelectedVideo('');
//     };

   
//     useEffect(() => {
//         fetchVideos();
//     }, []);

//     return (
//         <Box sx={{ flexGrow: 1, marginTop: 4 }}>
//             <Typography variant="h4" align="center" gutterBottom>
//                 Videos
//             </Typography>

//             {/* Show loading spinner while fetching data */}
//             {loading ? (
//                 <div className="d-flex justify-content-center">
//                     <CircularProgress animation="border" variant="primary" />
//                 </div>
//             ) : (
//                 <Grid container spacing={4} justifyContent="center">
//                     {videos.length > 0 ? (
//                         videos.map((video, index) => (
//                             <Grid item xs={12} sm={6} md={4} key={index}>
//                                 <Card sx={{
//                                     position: 'relative',
//                                     overflow: 'hidden',
//                                     borderRadius: 2,
//                                     '&:hover .cardMedia': {
//                                         transform: 'scale(1.1)',
//                                         transition: 'transform 0.5s ease',
//                                     },
//                                 }}>
//                                     <CardMedia
//                                         className="cardMedia"
//                                         sx={{
//                                             height: 0,
//                                             paddingTop: '56.25%', 
//                                             backgroundImage: `url(${video.thumbnail})`,
//                                             backgroundSize: 'cover',
//                                             transition: 'transform 0.5s ease',
//                                             cursor: 'pointer',
//                                         }}
//                                         onClick={() => handleOpenModal(video.videoUrl)}
//                                     />
//                                     <CardContent sx={{
//                                         backgroundColor: 'rgba(0, 0, 0, 0.6)',
//                                         color: 'white',
//                                         position: 'absolute',
//                                         bottom: 0,
//                                         width: '100%',
//                                         padding: 2,
//                                         opacity: 0,
//                                         transition: 'opacity 0.3s ease',
//                                         '&:hover': {
//                                             opacity: 1,
//                                         },
//                                     }}>
//                                         <Typography variant="h6" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
//                                             {video.title}
//                                         </Typography>
//                                         <Typography variant="body2">
//                                             {video.description}
//                                         </Typography>
//                                     </CardContent>
//                                 </Card>
//                             </Grid>
//                         ))
//                     ) : (
//                         <Typography variant="h6" align="center" sx={{ width: '100%' }}>
//                             No videos available
//                         </Typography>
//                     )}
//                 </Grid>
//             )}

//             {/* Modal for Video Playback */}
//             <Modal open={openModal} onClose={handleCloseModal}>
//                 <Box sx={{
//                     position: 'absolute',
//                     top: '50%',
//                     left: '50%',
//                     transform: 'translate(-50%, -50%)',
//                     backgroundColor: 'black',
//                     padding: 2,
//                     borderRadius: 2,
//                 }}>
//                     <ReactPlayer url={selectedVideo} playing controls width="100%" height="auto" />
//                 </Box>
//             </Modal>
//         </Box>
//     );
// };

// export default Videos;






// src/components/Videos.jsx
import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardMedia, Grid, Typography, Box, Modal, CircularProgress } from '@mui/material';
import ReactPlayer from 'react-player'; 
import axios from 'axios'; 

const Videos = () => {
    const [videos, setVideos] = useState([]); 
    const [openModal, setOpenModal] = useState(false); 
    const [selectedVideo, setSelectedVideo] = useState(''); 
    const [loading, setLoading] = useState(true); 

    const fetchVideos = async () => {
        try {
            const response = await axios.get('https://wedding-backend-pi.vercel.app/api/videos/'); 
            setVideos(response.data); 
            setLoading(false);
        } catch (error) {
            console.error('Error fetching videos:', error);
            setLoading(false); 
        }
    };

    const handleOpenModal = (videoUrl) => {
        setSelectedVideo(videoUrl);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedVideo('');
    };

    useEffect(() => {
        fetchVideos();
    }, []);

    return (
        <Box sx={{ flexGrow: 1, marginTop: 4 }}>
            <Typography variant="h4" align="center" gutterBottom>
                Videos
            </Typography>

            {/* Show loading spinner while fetching data */}
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Grid container spacing={4} justifyContent="center">
                    {videos.length > 0 ? (
                        videos.map((video, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Card sx={{
                                    position: 'relative',
                                    overflow: 'hidden',
                                    borderRadius: 2,
                                    height: 300, // Fixed height for consistency
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    '&:hover .cardMedia': {
                                        transform: 'scale(1.1)',
                                        transition: 'transform 0.5s ease',
                                    },
                                }}>
                                    <CardMedia
                                        className="cardMedia"
                                        sx={{
                                            height: 180, // Set a fixed height for all images
                                            backgroundImage: `url(${video.thumbnail})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            transition: 'transform 0.5s ease',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => handleOpenModal(video.videoUrl)}
                                    />
                                    <CardContent sx={{
                                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                        color: 'white',
                                        padding: 2,
                                    }}>
                                        <Typography variant="h6" sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                                            {video.title}
                                        </Typography>
                                        <Typography 
                                            variant="body2" 
                                            sx={{
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                WebkitLineClamp: 1, // Show only one line
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {video.description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                    ) : (
                        <Typography variant="h6" align="center" sx={{ width: '100%' }}>
                            No videos available
                        </Typography>
                    )}
                </Grid>
            )}

            {/* Modal for Video Playback */}
            <Modal open={openModal} onClose={handleCloseModal}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'black',
                    padding: 2,
                    borderRadius: 2,
                }}>
                    <ReactPlayer url={selectedVideo} playing controls width="100%" height="auto" />
                </Box>
            </Modal>
        </Box>
    );
};

export default Videos;
